import "./supplychain.css";
import Footer from "../components/Footer.js";
import Navbar from "../components/Navbar.js";

const Enhanced = () => {

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>
      {/* Enhanced Customer Experience Section */}

      <div className="supply-container">
        <div className="supply-header">
          <h1 className="supply-title">
            AI Powered Enhanced <br />
            Customer Experience
          </h1>
          <p className="supply-description">
            From the moment someone walks in, we help you see what matters—where
            customers go, what catches their eye, and when they need help
            <br class="responsive-br" /> It’s like giving your space a sixth
            sense. Shoppers get smoother, more personalized experiences without
            ever having to ask.
            <br class="responsive-br" /> You get real-time insights to act
            faster and serve smarter.
          </p>
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="enhanced1.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>OPTIMIZED THE CHECKOUT PROCESSES</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Higher Conversion rate by guiding customer towards key products.
          </h4>
          <ul className="featuresSupply">
            <li>Faster checkout, boost efficiency.</li>
            <li>Cut wait times, improve shopping.</li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <h1>EXTENDED USER INTERACTION PERIOD</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Encouraging longer visits, during higher purchase opportunities.
          </h4>
          <ul className="features">
            <li>Maximizing sales opportunities</li>
            <li>Better product placement insights</li>
          </ul>
        </div>
        <div className="image-section">
          <img src="enhanced2.png" alt="Product Line" />
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="enhanced3.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>OPTIMIZE PRODUCT VISIBILITY BY 15%</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Aligning staff resources with peak traffic for smoother operations.
          </h4>
          <ul className="featuresSupply">
            <li>Maximizing sales opportunities</li>
            <li>Better Product Placement Insights</li>
          </ul>
        </div>
      </div>
<div>
</div>
      <Footer />
    </div>
  );
};

export default Enhanced;
